import styled from "styled-components";

import {
  FlexContainer,
  FlexDiv,
  FlexSection,
  Button,
} from "@/components/Atoms";
import StyledSvgSprite from "@/components/Atoms/SVGSprite";
import { Typography } from "@/foundation/Typography/V2";

export const WrapContainer = styled(FlexContainer)`
  gap: 24px;
  @media only screen and (max-width: 1079px) {
    justify-content: space-between;
    flex-direction: column;
    gap: 0;
  }
`;

export const FixedSection = styled(FlexSection)`
  opacity: 0;
  visibility: hidden;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  transition: all 0.3s ease-in-out;
  background-color: ${({ theme }) => theme.colors.white};
  z-index: 1000;
  box-shadow: 0px -4px 20px rgba(${({ theme }) => theme.colors.shadows.black}, 0.02);
  @media only screen and (max-width: 1023px) {
    opacity: 1;
    background-color: ${({ theme }) => theme.colorsV2.shyft.purple_text};
    visibility: visible;
  }
`;

export const LHSSection = styled(FlexDiv)`
  max-width: 40%;
  width: 100%;
  @media only screen and (max-width: 1079px) {
    max-width: 100%;
    margin-bottom: 20px;
  }
`;

export const RHSSection = styled(FlexDiv)`
  max-width: 60%;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  @media only screen and (max-width: 1079px) {
    max-width: 100%;
  }
  @media only screen and (max-width: 600px) {
    overflow-x: scroll;
  }
`;

export const Icon = styled(StyledSvgSprite)`
  position: absolute;
  top: 50%;
  left: 0px;
  transform: translateY(-50%);
  height: 24px;
  width: 24px;
`;

export const CTAButton = styled(Button)`
  width: 100%;
  max-width: 230px;
  padding: 7px 20px;
  p {
    margin: 0 auto;
    position: relative;
    padding-left: 40px;
    max-width: 120px;
    font-size: 16px;
    font-family: var(--man-700);
    text-align: left;
    width: max-content;
    @media only screen and (max-width: 1079px) {
      font-size: 14px;
    }
    @media only screen and (max-width: 369px) {
      font-size: 12px;
    }
  }
  @media only screen and (max-width: 1079px) {
    margin: 0px;
  }
  @media only screen and (max-width: 369px) {
    padding: 7px 10px;
  }
`;

export const SecondaryCTAButton = styled(CTAButton)`
  min-height: 64px;
  p {
    max-width: unset;
  }
`;

export const Heading = styled(Typography)`
  color: ${({ theme }) => theme.colorsV2.primary.shade_700};
  @media only screen and (max-width: 1023px) {
    color: ${({ theme }) => theme.colors.white};
  }
`;

export const Description = styled(Typography)`
  color: ${({ theme }) => theme.colorsV2.rose.shade_400};
`;

export const ButtonDescription = styled(Typography)`
  margin-top: 8px;
`;

export const Subtitle = styled(Typography)`
  color: ${({ theme }) => theme.colorsV2.gray.shade_600};
  max-width: 304px;
`;
